import React from 'react';

const Note = ({...props}) => {
    const noteData = props.noteData;

    return (
        <>{noteData &&
        <div className='flex flex-col mb-4'>
            <p className='text-red-600'>Note:</p>
            <ol className='text-red-600'>
                <div dangerouslySetInnerHTML={{ __html: noteData }}></div>
            </ol>
        </div>
        }</>
    );
}

export default Note;